import PubSub from 'vanilla-pubsub'
import projectBase from '../projectBase'

export default class Viewport {
  constructor() {
    this.root = document.documentElement

    this.bind()

    if (!this.root.style['--vh']) {
      this.onResize()
    }
  }

  bind() {
    this.onResize = this.onResize.bind(this)
    this.onLoad = this.onLoad.bind(this)

    window.addEventListener('load', this.onLoad)
    PubSub.subscribe('App.resize', this.onResize)
  }

  onLoad() {
    const { width, height } = projectBase.state
    const vw = width / 100
    const vh = height / 100
    const fvw = window.outerHeight / 100 // SP時、OS UI込のサイズとして
    const fvh = window.outerWidth / 100 // SP時、OS UI込のサイズとして

    // 初期値固定
    this.root.style.setProperty('--sw', `${vw}px`)
    this.root.style.setProperty('--sh', `${vh}px`)
    this.root.style.setProperty('--fsw', `${fvw}px`)
    this.root.style.setProperty('--fsh', `${fvh}px`)
  }

  onResize(state) {
    const { width, height } = state || projectBase.state
    const vw = width / 100
    const vh = height / 100

    // 各カスタムプロパティに`window.innerHeight / 100`,`window.innerWidth / 100`の値をセット
    this.root.style.setProperty('--vh', `${vh}px`)

    if (vh > vw) {
      this.root.style.setProperty('--vmax', `${vh}px`)
      this.root.style.setProperty('--vmin', `${vw}px`)
    } else {
      this.root.style.setProperty('--vmax', `${vw}px`)
      this.root.style.setProperty('--vmin', `${vh}px`)
    }
  }
}
